import React, { useEffect, useState, useMemo } from 'react';
import MUIDataTable from 'mui-datatables';
import axios from 'axios';
import config from '../config/config';
import {
  Menu,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Grid,
  Avatar,

  TextField,
 
  InputAdornment,
  Chip,
} from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  AccountBalance as BalanceIcon,
  Payments as PaymentsIcon,
  MoneyOff as MoneyOffIcon,
   Search as SearchIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Students = () => {
  const [data, setData] = useState([]);
  const [termm, setTerm] = useState([]);
  const [selectedClass, setSelectedClass] = useState([]);
  const [selectedTerm, setSelectedTerm] = useState([]);
  const [total, setTotal] = useState(0);
  const [data2, setData2] = useState([]);
  const [total2, setTotal2] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [terms, setTerms] = useState([]);
  const navigate = useNavigate();
const [inputValue, setInputValue] = useState(""); 
  const fetchTerms = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullterms`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setTerms(res.data.terms || res.data || []);
    } catch (err) {
      console.error('Error fetching terms:', err);
    }
  };


const handleSearch = () => {
    setSearchText(inputValue);
    setPage(0);
  };
 

  
   

  const fetchStudents = async (page = 0, rowsPerPage = 10, searchText = '') => {
    setLoading(true);
    const token = localStorage.getItem('token');

    try {
     
      const res = await axios.get(config.API_URL + '/api/pullinvoices/'+termm, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: page + 1,
          per_page: rowsPerPage,
          search: searchText,
        },
      });

      setData(res.data.data);
      setTotal(res.data.total);
      fetchStudentsMain(termm);
      
    } catch (err) {
      console.error('Error fetching invoices:', err);
    } finally {
      setLoading(false);
    }
  };

   const setSearchTextTerm = (term) => {
    setTerm(term);
    fetchStudentsMain(term);
  };

   const formatCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-KE', {
    style: 'currency',
    currency: 'KES',
    minimumFractionDigits: 2
  }).format(amount);
};


const classGrades = [
    { value: 'PG', label: 'Playgroup (2-3 years)' },
    { value: 'PP1', label: 'Pre-primary 1 (4-5 years)' },
    { value: 'PP2', label: 'Pre-primary 2 (4-5 years)' },
    { value: 'G1', label: 'Grade 1 (6-8 years)' },
    { value: 'G2', label: 'Grade 2 (6-8 years)' },
    { value: 'G3', label: 'Grade 3 (6-8 years)' },
    { value: 'G4', label: 'Grade 4 (9 years)' },
    { value: 'G5', label: 'Grade 5 (9 years)' },
    { value: 'G6', label: 'Grade 6 (11 years)' },
  ];

  const fetchStudentsMain = async (term=null) => {
    setTerm(term);
    setLoading(true);
    const token = localStorage.getItem('token');

    try {
      const res = await axios.get(config.API_URL + '/api/pullinvoices/'+term, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: page + 1,
          per_page: 1000,
          search: searchText,
        },
      });

      const ress = await axios.get(config.API_URL + '/api/pullinvoices/'+term, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: page + 1,
          per_page: rowsPerPage,
          search: searchText,
        },
      });
      //setSearchText(term);

       setData2(res.data.data);
      setTotal2(res.data.total);
     
      setData(ress.data.data);
      setTotal(ress.data.total);
      
      
   
    } catch (err) {
      console.error('Error fetching invoices:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents(page, rowsPerPage, searchText);
    fetchStudentsMain(termm);
    fetchTerms();
  }, [page, rowsPerPage, searchText]);

  // Calculate financial metrics
  const stats = useMemo(() => {
    const totalBalance = data2.reduce((sum, invoice) => sum + (Number(invoice.grand_total) || 0), 0);
    const moneyPaid = data2.reduce((sum, invoice) => sum + (Number(invoice.paid_amount) || 0), 0);
    const balance = data2.reduce((sum, invoice) => sum + (Number(invoice.balance) || 0), 0);

    return {
      totalBalance: totalBalance,
      moneyPaid: moneyPaid,
      balance: balance,
    };
  }, [data2]);
  const MetricCard = ({ title, value, icon, gradient }) => (
    <Card
      elevation={0}
      sx={{
        background: gradient,
        borderRadius: '16px',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        transition: 'transform 0.2s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100px',
          height: '100px',
          background: 'rgba(255,255,255,0.1)',
          borderRadius: '50%',
          transform: 'translate(30%, -30%)',
        },
      }}
    >
      <CardContent sx={{ p: 3, position: 'relative', zIndex: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 3 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: '12px',
              bgcolor: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            {icon}
          </Box>
        </Box>
        <Typography
          variant="body2"
          sx={{
            color: 'rgba(255,255,255,0.85)',
            fontSize: '0.813rem',
            fontWeight: 500,
            mb: 1,
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="h4"
          sx={{
            color: '#fff',
            fontWeight: 600,
            fontSize: '1.75rem',
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );

  const handleMenuClick = (event, student) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedStudent(student);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleView = () => {
    setOpenModal(true);
    handleMenuClose();
  };



  const columns = useMemo(
    () => [
      {
        name: 'term',
        label: 'Term',
        options: {
          filter: true,
          customBodyRender: (value) => (
            <Chip label={value} size="small" sx={{ bgcolor: '#f3f4f6', fontWeight: 500 }} />
          ),
        },
      },
      {
        name: 'class_admitted_to',
        label: 'Class',
        options: {
          filter: true,
          filterOptions: classGrades.map((g) => g.value),
          customBodyRender: (value) => (
            <Typography sx={{ fontWeight: 500, color: '#374151' }}>{value}</Typography>
          ),
        },
      },
      {
        name: 'reference_no',
        label: 'Reference No',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontFamilyy: 'monospace', fontSize: '0.813rem', color: '#6b7280' }}>
              {value}
            </Typography>
          ),
        },
      },
      { name: 'admission_number', label: 'Admission No', options: { filter: false } },
      {
        name: 'name',
        label: 'Name',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontWeight: 500, color: '#111827' }}>{value}</Typography>
          ),
        },
      },
      {
        name: 'grand_total',
        label: 'Fee Amount',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontWeight: 600, color: '#111827' }}>{formatCurrency(value)}</Typography>
          ),
        },
      },
      {
        name: 'paid_amount',
        label: 'Fee Paid',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontWeight: 600, color: '#059669' }}>{formatCurrency(value)}</Typography>
          ),
        },
      },
      {
        name: 'balance',
        label: 'Balance',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontWeight: 600, color: value > 0 ? '#dc2626' : '#6b7280' }}>
              {formatCurrency(value)}
            </Typography>
          ),
        },
      },
      {
        name: 'created_at',
        label: 'Invoiced On',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontSize: '0.813rem', color: '#6b7280' }}>{value}</Typography>
          ),
        },
      },
      {
        name: 'actions',
        label: 'Actions',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => (
            <IconButton
              onClick={(e) => handleMenuClick(e, data[tableMeta.rowIndex])}
              size="small"
              sx={{
                '&:hover': { bgcolor: '#f3f4f6' },
              }}
            >
              <MoreVertIcon sx={{ fontSize: 20 }} />
            </IconButton>
          ),
        },
      },
    ],
    [data]
  );

  const options = useMemo(
    () => ({
      search: false,
      filter: true,
      download: true,
      print: true,
      pagination: true,
      serverSide: true,
      count: total,
      rowsPerPage,
      page,
      selectableRows: 'none',
      elevation: 0,
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
            setPage(tableState.page);
            break;
          case 'changeRowsPerPage':
            setRowsPerPage(tableState.rowsPerPage);
            setPage(0);
            break;
          default:
            break;
        }
      },
      onRowClick: (rowData, rowMeta) => {
        const student = data[rowMeta.dataIndex];
        navigate(`/students/${student.id}/viewinvoice`);
      },
      setTableProps: () => ({
        sx: {
          '& .MuiTableCell-head': {
            bgcolor: '#fafafa',
            color: '#374151',
            fontWeight: 600,
            fontSize: '0.813rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            borderBottom: '2px solid #e5e7eb',
          },
          '& .MuiTableCell-body': {
            fontSize: '0.875rem',
            color: '#4b5563',
            borderBottom: '1px solid #f3f4f6',
          },
          '& .MuiTableRow-root:hover': {
            bgcolor: '#fafafa',
            cursor: 'pointer',
          },
        },
      }),
    }),
    [total, page, rowsPerPage, data, navigate]
  );

  return (
    <Box sx={{ p: { xs: 3, md: 5 }, bgcolor: '#fafafa', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ mb: 5 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: '#111827',
            mb: 0.5,
            fontSize: { xs: '1.75rem', md: '2.125rem' },
          }}
        >
          Student Invoices
        </Typography>
        <Typography variant="body2" sx={{ color: '#6b7280', fontSize: '0.938rem' }}>
          Manage and track student fee invoices
        </Typography>
      </Box>

      {/* Financial Metrics */}
      <Grid container spacing={3} sx={{ mb: 5 }}>
        <Grid item xs={12} md={4}>
          <MetricCard
            title="Total Fee Amount"
            value={formatCurrency(stats.totalBalance)}
            icon={<MoneyOffIcon sx={{ fontSize: 24, color: '#fff' }} />}
            gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MetricCard
            title="Money Paid"
            value={formatCurrency(stats.moneyPaid)}
            icon={<MoneyOffIcon sx={{ fontSize: 24, color: '#fff' }} />}
            gradient="linear-gradient(135deg, #10b981 0%, #059669 100%)"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MetricCard
            title="Balance"
            value={formatCurrency(stats.balance)}
            icon={<MoneyOffIcon sx={{ fontSize: 24, color: '#fff' }} />}
            gradient="linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
          />
        </Grid>
      </Grid>

      {/* Filters and Search */}
      <Card elevation={0} sx={{ mb: 4, borderRadius: '16px', border: '1px solid #e5e7eb' }}>
        <CardContent sx={{ p: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                placeholder="Search by admission number or name..."
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#9ca3af', fontSize: 20 }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',
                    bgcolor: '#fafafa',
                    fontSize: '0.875rem',
                    '& fieldset': { borderColor: '#e5e7eb' },
                    '&:hover fieldset': { borderColor: '#d1d5db' },
                    '&.Mui-focused fieldset': { borderColor: '#667eea', borderWidth: '2px' },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={2.5}>
              <Select
                fullWidth
                value={selectedClass}
                onChange={(e) => {
                  setSelectedClass(e.target.value);
                  setPage(0);
                }}
                displayEmpty
                sx={{
                  borderRadius: '10px',
                  bgcolor: '#fafafa',
                  fontSize: '0.875rem',
                  '& fieldset': { borderColor: '#e5e7eb' },
                  '&:hover fieldset': { borderColor: '#d1d5db' },
                  '&.Mui-focused fieldset': { borderColor: '#667eea', borderWidth: '2px' },
                }}
              >
                <MenuItem value="">All Classes</MenuItem>
                {classGrades.map((grade) => (
                  <MenuItem key={grade.value} value={grade.value}>
                    {grade.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} md={2.5}>
              <Select
                fullWidth
                value={selectedTerm}
                onChange={(e) => {
                  setSelectedTerm(e.target.value);
                  setPage(0);
                }}
                displayEmpty
                sx={{
                  borderRadius: '10px',
                  bgcolor: '#fafafa',
                  fontSize: '0.875rem',
                  '& fieldset': { borderColor: '#e5e7eb' },
                  '&:hover fieldset': { borderColor: '#d1d5db' },
                  '&.Mui-focused fieldset': { borderColor: '#667eea', borderWidth: '2px' },
                }}
              >
                <MenuItem value="">All Terms</MenuItem>
                {terms.map((term) => (
                  <MenuItem key={term.id} value={term.id}>
                    {term.term}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} md={3}>
              <Button
                fullWidth
                onClick={handleSearch}
                variant="contained"
                sx={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: '#fff',
                  borderRadius: '10px',
                  height: '56px',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  textTransform: 'none',
                  boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #5a67d8 0%, #6b3fa0 100%)',
                    boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)',
                  },
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Data Table */}
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
          <CircularProgress sx={{ color: '#667eea' }} />
        </Box>
      ) : (
        <Card elevation={0} sx={{ borderRadius: '16px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <MUIDataTable
            title={
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#111827', p: 2 }}>
                Invoices
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Card>
      )}

      {/* Actions Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          elevation: 0,
          sx: {
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
            mt: 1,
          },
        }}
      >
        <MenuItem
          onClick={(handleView)}
          sx={{
            fontSize: '0.875rem',
            fontWeight: 500,
            color: '#374151',
            '&:hover': { bgcolor: '#f3f4f6' },
          }}
        >
          View Details
        </MenuItem>
      </Menu>

      {/* Invoice Details Modal */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        PaperProps={{
          elevation: 0,
          sx: {
            borderRadius: '16px',
            maxWidth: '700px',
            border: '1px solid #e5e7eb',
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#111827', borderBottom: '1px solid #f3f4f6' }}>
          Invoice Details
        </DialogTitle>
        <DialogContent sx={{ mt: 3 }}>
          {selectedStudent && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '0.813rem', color: '#6b7280', fontWeight: 500 }}>ID</Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#111827', fontWeight: 600 }}>
                  {selectedStudent.id}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '0.813rem', color: '#6b7280', fontWeight: 500 }}>Class</Typography>
                <Chip
                  label={selectedStudent.class_admitted_to}
                  size="small"
                  sx={{ bgcolor: '#f3f4f6', fontWeight: 600 }}
                />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '0.813rem', color: '#6b7280', fontWeight: 500 }}>
                  Reference No
                </Typography>
                <Typography
                  sx={{ fontSize: '0.875rem', color: '#111827', fontFamilyy: 'monospace', fontWeight: 600 }}
                >
                  {selectedStudent.reference_no}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '0.813rem', color: '#6b7280', fontWeight: 500 }}>
                  Admission No
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#111827', fontWeight: 600 }}>
                  {selectedStudent.admission_number}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '0.813rem', color: '#6b7280', fontWeight: 500 }}>Name</Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#111827', fontWeight: 600 }}>
                  {selectedStudent.name}
                </Typography>
              </Box>
              <Box
                sx={{
                  mt: 2,
                  pt: 2.5,
                  borderTop: '1px solid #f3f4f6',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography sx={{ fontSize: '0.813rem', color: '#6b7280', fontWeight: 500 }}>
                    Fee Amount
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', color: '#111827', fontWeight: 700 }}>
                    {formatCurrency(selectedStudent.grand_total)}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography sx={{ fontSize: '0.813rem', color: '#6b7280', fontWeight: 500 }}>
                    Fee Paid
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', color: '#059669', fontWeight: 700 }}>
                    {formatCurrency(selectedStudent.paid_amount)}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography sx={{ fontSize: '0.813rem', color: '#6b7280', fontWeight: 500 }}>
                    Balance
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '1rem',
                      color: selectedStudent.balance > 0 ? '#dc2626' : '#6b7280',
                      fontWeight: 700,
                    }}
                  >
                    {formatCurrency(selectedStudent.balance)}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  mt: 1,
                  pt: 2.5,
                  borderTop: '1px solid #f3f4f6',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography sx={{ fontSize: '0.813rem', color: '#6b7280', fontWeight: 500 }}>
                  Invoiced On
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#111827', fontWeight: 600 }}>
                  {selectedStudent.created_at}
                </Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3, borderTop: '1px solid #f3f4f6' }}>
          <Button
            onClick={() => setOpenModal(false)}
            variant="contained"
            sx={{
              bgcolor: '#111827',
              color: '#fff',
              borderRadius: '10px',
              px: 4,
              fontWeight: 600,
              textTransform: 'none',
              '&:hover': { bgcolor: '#1f2937' },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Students;